export interface HeaderProps {
  isDark?: boolean
}

export const HeaderSimple = ({ isDark = true }: HeaderProps) => {
  let theme = isDark
    ? {
        navbarClass: "navbar navbar-expand-lg light",
        logo: "white",
      }
    : {
        navbarClass: "navbar navbar-expand-lg dark",
        logo: "black",
      }

  return (
    <header className="header steps__header">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-2">
            <a className="steps__logo" href="/">
              <img src={"img/logo_" + theme.logo + ".png"} alt="logo" className="steps__logo_img" />
            </a>
          </div>
          <div className="col-lg-10">
            <span className="steps__slogan d-block">
              Buy crypto with a credit card
              <br /> no deposit is required
            </span>
          </div>
        </div>
      </div>
    </header>
  )
}
